import { emptyCustomsItem } from '../../services/customs-service';

export const getCustomsItemsCount = (customsItems) => {
  const emptyItem = emptyCustomsItem();
  const customsItemsCount = customsItems.length;

  if (
    customsItemsCount === 1 &&
    customsItems[0].description === emptyItem.description &&
    customsItems[0].unitPrice.value === 0 &&
    customsItems[0].harmonizedTariffCode === emptyItem.harmonizedTariffCode &&
    customsItems[0].fulfillmentPlanItemId === emptyItem.fulfillmentPlanItemId
  ) {
    return 0;
  }

  return customsItemsCount;
};
